export default __webpack_public_path__ + "static/media/background-home.10fe0960.png";